module.exports = __webpack_public_path__ + "img/nameYes.1ba4b6c1.png";